<template>
  <div class="info-box clearfix">
    <h5 v-if="title">{{title}}</h5>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: { default: null }
  },
  methods: {
  },
}
</script>

<style>
.info-box {
  color: #887642;
  position: relative;
  padding: 1em;
  margin: 0.5em;
  border: 1px solid #f1d88d;
  background: linear-gradient(135deg, #FFE79C 81%, #FFE79C 82%, #FFE79C 82%, #ffffc6 100%);
  box-shadow: 0 3px 4px 0 #21212114;
  line-height: 1.4;
  word-break: break-word;
}

</style>
